/**
 * Inline "+ Direct URL" + "+ Campaign" buttons placed alongside the standard
 * "+ Offer" picker trigger.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC } from 'react';
import { Globe, Megaphone } from 'lucide-react';

import { Button } from '@/components/ui/layout/Button';

export interface BinomOfferExtraButtonsProps {
  onDirectUrl: () => void;
  onCampaign: () => void;
}

const BinomOfferExtraButtons: FC<BinomOfferExtraButtonsProps> = ({
  onDirectUrl,
  onCampaign,
}) => (
  <>
    <Button
      type="button"
      variant="ghost"
      size="sm"
      className="h-6 gap-1 px-1.5 text-[10px]"
      onClick={onDirectUrl}
      aria-label="Attach direct URL offer"
    >
      <Globe className="h-3 w-3" aria-hidden /> Direct URL
    </Button>
    <Button
      type="button"
      variant="ghost"
      size="sm"
      className="h-6 gap-1 px-1.5 text-[10px]"
      onClick={onCampaign}
      aria-label="Attach campaign as offer"
    >
      <Megaphone className="h-3 w-3" aria-hidden /> Campaign
    </Button>
  </>
);

export default BinomOfferExtraButtons;
